import { FormEvent, useCallback, useMemo, useState } from "react";
import {
  Modal,
  Stack,
  Box,
  Typography,
  IconButton,
  Autocomplete,
  TextField,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { desktopSx } from "src/utils/styles/modalStyles";
import {
  useGetProductsQuery,
  // useGetProductVariantsQuery,
} from "src/api/services/productsApi";
import { OnlineVisit, Product } from "src/api/types";
import { useUpdatePatientVisitMutation } from "src/api/services/onlineVisitsApi";

interface Props {
  open: boolean;
  onClose: () => void;
  visit: OnlineVisit | null;
}

const UpdateOnlineVisit = ({ open, onClose, visit }: Props) => {
  const { products } = useGetProductsQuery(undefined, {
    selectFromResult: ({ data }) => {
      return { products: data?.data ?? [] };
    },
  });

  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [updateVisit, { isLoading }] = useUpdatePatientVisitMutation();

  const selectableProducts = useMemo(() => {
    const category = visit?.product_category.name;

    return products.filter((p) => p.category.name === category);
  }, [products, visit?.product_category.name]);

  const handleSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      if (visit == null) return;
      try {
        updateVisit({
          id: visit.id,
          patient_id: visit.patient_id,
          body: {
            product_id: selectedProduct?.id,
            visit_type: visit.visit_type,
          },
        }).unwrap();

        setSelectedProduct(null);
        onClose();
      } catch (err) {
        console.error(err);
      }
    },
    [onClose, selectedProduct?.id, updateVisit, visit],
  );

  const handleProduct = useCallback(
    (_: React.SyntheticEvent<Element, Event>, value: Product | null) => {
      setSelectedProduct(value);
    },
    [],
  );

  // const handleVariant = useCallback(
  //   (_: React.SyntheticEvent<Element, Event>, value: ProductVariant | null) => {
  //     setSelectedVariant(value);
  //     setError("");
  //   },
  //   []
  // );

  // const showVariant = useMemo(() => {
  //   return selectedProduct != null && variants.length > 0;
  // }, [selectedProduct, variants.length]);

  // const handlePrice = useCallback(
  //   (_: React.SyntheticEvent<Element, Event>, value: ProductPrice | null) => {
  //     setSelectedPrice(value);
  //     setError("");
  //   },
  //   []
  // );

  // const showPrice = useMemo(() => {
  //   return selectedProduct != null && prices?.length > 0;
  // }, [prices?.length, selectedProduct]);

  return (
    <Modal open={open}>
      <Stack
        sx={desktopSx}
        gap={2}
        component="form"
        maxWidth={400}
        onSubmit={handleSubmit}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="h5" fontWeight={700}>
            Update Visit
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Box>

        <Stack gap={2}>
          <Autocomplete
            options={selectableProducts}
            getOptionLabel={(p) => p.name}
            value={selectedProduct}
            onChange={handleProduct}
            renderInput={(params) => (
              <TextField {...params} label="Product" required />
            )}
          />
          {/* <Collapse in={showVariant} unmountOnExit>
            <Autocomplete
              options={variants}
              getOptionLabel={(c) => `${c.label} - $${c.dosage}`}
              value={selectedVariant}
              onChange={handleVariant}
              renderInput={(params) => (
                <TextField {...params} label="Variant" />
              )}
            />
          </Collapse> */}
          {/* <Collapse in={showPrice} unmountOnExit>
            <Autocomplete
              options={prices}
              getOptionLabel={(c) => `${c.name} - $${c.amount}`}
              value={selectedPrice}
              onChange={handlePrice}
              renderInput={(params) => (
                <TextField {...params} label="Variant" />
              )}
            />
          </Collapse> */}
        </Stack>
        <Stack direction="row" gap={2}>
          <Button fullWidth loading={isLoading} type="submit">
            Update
          </Button>
          <Button variant="secondary" fullWidth onClick={onClose}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default UpdateOnlineVisit;
